import { SolitaireDealer } from '../logic/dealer/solitaire-dealer';
import { RemoteDealer } from '../logic/dealer/remote-dealer';
import { SolitaireListener } from '../game/solitaire-listener';
import { RemoteRoundParams, RoundParams } from 'src/games/common/phaser/model/round-params';
import { RemoteRoundResultSubmitter } from 'src/games/common/phaser/model/remote-round-result-submitter';

export class SolitaireRemoteRoundParams extends RemoteRoundParams {
  public readonly dealer: SolitaireDealer;

  constructor(dealer: SolitaireDealer, remoteRoundResultSubmitter: RemoteRoundResultSubmitter) {
    super(remoteRoundResultSubmitter);
    this.dealer = dealer;
  }

  public static create(solitaireListener: SolitaireListener): SolitaireRemoteRoundParams {
    const dealer = new RemoteDealer(solitaireListener);

    return new SolitaireRemoteRoundParams(
      dealer,
      new RemoteRoundResultSubmitter(solitaireListener),
    );
  }

  public static isRound(roundParams: RoundParams): roundParams is SolitaireRemoteRoundParams {
    return roundParams instanceof SolitaireRemoteRoundParams;
  }
}
